// Document ready
$(function(){
    
    // Init Tooltips
    //$('[data-bs-toggle="tooltip"]').tooltip();
    if( $('[data-bs-toggle="tooltip"]').length ) {
        $('body').tooltip({
            selector: '[data-bs-toggle="tooltip"]',
            container: '.has-tooltip'
        });
    }
    
    /* $('[data-bs-toggle="tooltip"]').tooltip({
        container: '.has-tooltip'
     }); */
    
    // var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    // var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    // return new bootstrap.Tooltip(tooltipTriggerEl)
    // })
});